import { StagedFile } from "./definitions";

export const getWizardDeleteInfo = (
  files: StagedFile[],
  suffix: string
): string => {
  const linkNum = files.filter((f) => f.link).length;
  const fileNum = files.filter((f) => f.file || f.originalDocument).length;

  if (linkNum > 0 && fileNum > 0) {
    return `Remove ${linkNum === 1 ? "link" : "links"} and ${
      fileNum === 1 ? "file" : "files"
    }${suffix}`;
  } else if (linkNum > 0) {
    return `Remove ${linkNum === 1 ? "link" : "links"}${suffix}`;
  } else if (fileNum > 0) {
    return `Remove ${fileNum === 1 ? "file" : "files"}${suffix}`;
  }

  return "Remove items" + suffix;
};
